import { render, staticRenderFns } from "./FloatingTitleBadge.vue?vue&type=template&id=086d631c&scoped=true&"
import script from "./FloatingTitleBadge.vue?vue&type=script&lang=js&"
export * from "./FloatingTitleBadge.vue?vue&type=script&lang=js&"
import style0 from "./FloatingTitleBadge.vue?vue&type=style&index=0&id=086d631c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086d631c",
  null
  
)

export default component.exports